<template>
  <div>
    <my-header></my-header>
    <loading :active.sync="isLoading"></loading>
    <div class="contents">

      <div class="items">
        <div class="item">
          <div class="key">
            ニックネーム
          </div>
          <input
            type="text"
            class="value"
            v-model="nickname"
          >
        </div>
        <div class="item">
          <div class="key">
            都道府県
          </div>
          <select
            class="value"
            v-model="selected_pref"
          >
            <option
              v-for="pref in pref_all"
              :key="pref.index"
              :value="pref"
              type="text"
            >
              {{pref}}
            </option>
          </select>
        </div>
      </div>

      <div
        @click="send"
        class="send_btn"
      >
        設定完了
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import firebase from "firebase";

export default {
  data() {
    return {
      uuid: this.$store.state.user.uuid,
      nickname: this.$store.state.user.nickname,
      self_introduction: this.$store.state.user.self_introduction,
      selected_pref: this.$store.state.user.pref,
      pref_all: [
        "北海道",
        "青森県",
        "岩手県",
        "宮城県",
        "秋田県",
        "山形県",
        "福島県",
        "茨城県",
        "栃木県",
        "群馬県",
        "埼玉県",
        "千葉県",
        "東京都",
        "神奈川県",
        "新潟県",
        "富山県",
        "石川県",
        "福井県",
        "山梨県",
        "長野県",
        "岐阜県",
        "静岡県",
        "愛知県",
        "三重県",
        "滋賀県",
        "京都府",
        "大阪府",
        "兵庫県",
        "奈良県",
        "和歌山県",
        "鳥取県",
        "島根県",
        "岡山県",
        "広島県",
        "山口県",
        "徳島県",
        "香川県",
        "愛媛県",
        "高知県",
        "福岡県",
        "佐賀県",
        "長崎県",
        "熊本県",
        "大分県",
        "宮崎県",
        "鹿児島県",
        "沖縄県"
      ],
      isLoading: false
    };
  },
  components: {
    MyHeader
  },
  methods: {
    async send() {
      const self = this;
      if (this.isLoading) return;
      this.isLoading = true;
      // 初めての登録の場合はuuidを登録する
      console.log("this.$store.state.user.uuid " + this.$store.state.user.uuid);
      if (this.$store.state.user.uuid == "") {
        this.uuid = this.generateUuid();
      }
      console.log("this.nickname: " + this.nickname);
      console.log("this.self_introduction: " + this.self_introduction);
      console.log("self.selected_pref " + self.selected_pref);
      console.log("self.uuid " + self.uuid);
      firebase
        .firestore()
        .collection("users")
        .doc(this.uuid)
        .set({
          uuid: this.uuid,
          nickname: this.nickname,
          self_introduction: this.self_introduction,
          pref: this.selected_pref
        })
        .then(function() {
          self.isLoading = false;
          console.log("Document successfully written!");
          self.$store.commit("user/set_uuid", self.uuid);
          self.$store.commit("user/set_nickname", self.nickname);
          self.$store.commit(
            "user/set_self_introduction",
            self.self_introduction
          );
          self.$store.commit("user/set_pref", self.selected_pref);
          alert("設定完了！");
          self.$router.go(-1);
        })
        .catch(function(error) {
          self.isLoading = false;
          console.error("Error writing document: ", error);
        });
    },
    generateUuid() {
      // https://qiita.com/psn/items/d7ac5bdb5b5633bae165
      // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
      // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
      let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
      for (let i = 0, len = chars.length; i < len; i++) {
        switch (chars[i]) {
          case "x":
            chars[i] = Math.floor(Math.random() * 16).toString(16);
            break;
          case "y":
            chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
            break;
        }
      }
      return chars.join("");
    }
  }
};
</script>

<style lang="scss" scoped>
.contents {
  margin-top: 3vh;
  .items {
    margin-bottom: 20vh;
    .item {
      height: 6vh;
      line-height: 6vh;
      margin-bottom: 2vh;
      vertical-align: middle;
      .key {
        display: inline-block;
        text-align: right;
        padding-right: 3vw;
        font-weight: bold;
        width: 35vw;
        font-size: 0.9rem;
      }
      .value {
        display: inline-block;
        width: 60vw;
        padding-left: 1vw;
        line-height: 5vh;
        background-color: white;
        border: solid 1px rgb(245, 245, 245);
      }
    }
  }
}
</style>
